module.exports = __webpack_public_path__ + "assets/img/hjmxg.5480cf7b.jpg";